import React from 'react';
import { IconSvgProps } from '@models/common';

const Settings: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.3333 6.49967L22.75 6.49968M3.25 6.49967L13 6.49968M3.25 19.4997L13 19.4997M3.25 12.9997H8.66667M13 12.9997H22.75M17.3333 19.4997H22.75M17.3333 4.33301V8.66634M8.66667 10.833V15.1663M17.3333 17.333V21.6663'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Settings;
